export default {
  "AgreementCardTitle.Title": "パーソナルデータの取扱いに関する同意事項",
  "AgreementCardTitle.Description":
    "{name} のお申込みにあたり、下記事項に同意をいただきます",
}
